module.exports = __webpack_public_path__ + "img/face-verification.ad4690a8.png";